module.exports = __webpack_public_path__ + "static/media/icons_Bilan Uro-gynécologie.25b28c66.svg";